import { Button } from "@appretio/ui-kit";
import { useNavigate } from "react-router-dom";
import {
  copyrightText,
  errorCode,
  notFoundCard,
  notFoundContentContainer,
  notFoundMainContent,
  notFoundMessage,
  notFoundPageBase,
  notFoundTitle
} from "./NotFoundPage.css";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className={notFoundPageBase}>
      <div className={notFoundMainContent}>
        <div className={notFoundContentContainer}>
          <div className={notFoundCard}>
            <p className={errorCode}>404</p>
            <h1 className={notFoundTitle}>Page not found</h1>
            <p className={notFoundMessage}>
              The page you are looking for does not exist or has been moved.
            </p>

            <Button variant="primary" onClick={() => navigate("/")}>
              Go to Home
            </Button>
          </div>
        </div>
      </div>
      <p className={copyrightText}>© Appretio {new Date().getFullYear()}</p>
    </div>
  );
}
